// extracted by mini-css-extract-plugin
module.exports = {"quiz__title":"quizzes-module__quiz__title___A02vW","quiz__cards":"quizzes-module__quiz__cards___3nVUI","quiz__more":"quizzes-module__quiz__more___Z6Psb"};